import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../../css/DesignSystem/Dropdowns/CheckboxMultiSelect.css";

const CheckboxMultiSelect = ({
  label,
  required = false,
  value = [],
  options = [],
  placeholder = "Select options",
  helperText = "Select all relevant options",
  disabled = false,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedLabels = useMemo(() => {
    return options
      .filter((option) => value.includes(option.value))
      .map((option) => option.label);
  }, [options, value]);

  const displayValue = selectedLabels.length
    ? selectedLabels.join(", ")
    : placeholder;

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const toggleDropdown = () => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
  };

  const toggleOption = (optionValue) => {
    if (disabled) return;

    const alreadySelected = value.includes(optionValue);

    const nextValue = alreadySelected
      ? value.filter((item) => item !== optionValue)
      : [...value, optionValue];

    onChange(nextValue);
  };

  const clearAll = (event) => {
    event.stopPropagation();
    onChange([]);
  };

  return (
    <div
      ref={dropdownRef}
      className={`fp-form-column CheckboxMultiSelect ${
        disabled ? "CheckboxMultiSelect--Disabled" : ""
      }`}
    >
      {label && (
        <span className="FP_Content_Semibold">
          {label}
          {required && <span className="fp-form-required">*</span>}
        </span>
      )}

      <button
        type="button"
        className={`CheckboxMultiSelect__Trigger ${
          isOpen ? "CheckboxMultiSelect__Trigger--Open" : ""
        }`}
        onClick={toggleDropdown}
        disabled={disabled}
      >
        <span
          className={
            selectedLabels.length
              ? "CheckboxMultiSelect__Value FP_Content"
              : "CheckboxMultiSelect__Placeholder"
          }
        >
          {displayValue}
        </span>

        <span className="CheckboxMultiSelect__Right">
          {!!selectedLabels.length && (
            <span className="CheckboxMultiSelect__Count">
              {selectedLabels.length}
            </span>
          )}

          <span
            className={`CheckboxMultiSelect__Arrow ${
              isOpen ? "CheckboxMultiSelect__Arrow--Open" : ""
            }`}
          />
        </span>
      </button>

      {isOpen && (
        <div className="CheckboxMultiSelect__Menu">
          <div className="CheckboxMultiSelect__MenuHeader">
            <span className="FP_Content_Small">{helperText}</span>

            {!!selectedLabels.length && (
              <button type="button" onClick={clearAll}>
                Clear
              </button>
            )}
          </div>

          <div className="CheckboxMultiSelect__Options">
            {options.map((option) => (
              <label key={option.value} className="CheckboxMultiSelect__Option">
                <input
                  checked={value.includes(option.value)}
                  type="checkbox"
                  onChange={() => toggleOption(option.value)}
                />

                <span>{option.label}</span>
              </label>
            ))}
          </div>

          <div className="CheckboxMultiSelect__Footer">
            <button type="button" onClick={() => setIsOpen(false)}>
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckboxMultiSelect;
